import './App.css';
import { CompRutas } from './navegacion/rutas';
import axios from "axios"
import './App.css';

function App() {
  axios.interceptors.request.use(
    config => {
      config.headers['Authorization'] = `Bearer ${localStorage.getItem('camulabo_valid_session')}`;
          return config;
      },
      error => {
          return Promise.reject(error);
      }
)
    return ( 
      <div className="App">           
        <CompRutas />    
      </div>
  );
}



export default App;
